export default {
  showTitle: (s,v,p) => {
    //Get vendor
    var vendor = p.vendor;
    var t = (vendor) ? `${vendor.toUpperCase()}, ${p.title}` : p.title;
    var price = v.products.showPrice(s,v,p);

    return `${t}, <span class="price">${price}</span>`;
  },
  showPrice: (s,v,p) => {
    return v.product.showPrice(s,v, p);
  },
  showMood: (state, view, product) => {
    var image_path = (product.images.length > 1) ? product.images[1] : product.images[0];

    image_path = view.app.showImage(image_path, '600x800_crop_center');

    return {'background-image': `url(${image_path}`};
  },
  showSearchTitle: (search) => {
    return `'${search.terms}'<br>Results (${search.total})`;
  },
  hasSalePrice: (state, view, variant) => {
    var price    = variant.price;
    var original = variant.compare_at_price;
    return original != null && original < price;
  },
  formatCollections: (data, view) => {
    // Group products by collection
    var product_groups = _.map(data.product_groups, (pg) => {
      pg.collection.is_collection = true;

      return _.concat(pg.collection, view.products.formatProducts(data, pg.products, true));
    });

    return _.flatten(product_groups);
  },
  formatProducts: (data, products_data, is_shop = false, is_search = false) => {
    return _.map(products_data, (p) => {
      return {
        title: p.title,
        price: p.price,
        original_price: p.compare_at_price,
        tags: p.tags,
        images: p.images,
        variants: p.variants,
        available: p.available,
        vendor: p.vendor,
        image: (p.images) ? p.images[0] : false,
        url: `/products/${p.handle}`
      }
    });
  },
  getResize: (product) => {
     return '600x800_crop_center';
  },
}